import { LazyPage, MobileAuthorizePage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

// Sign-in page the mobile app opens in a browser sheet. Outside any workspace:
// the page itself sends a signed-out user to login and back.
function MobileAuthorizeRoute() {
  return (
    <LazyPage>
      <MobileAuthorizePage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/mobile/authorize')({
  component: MobileAuthorizeRoute,
});
